import { pick } from "lodash";
import { getCommonInUsers } from "../../../../../utils/helpers/user";

export const getCommonProperty = (user: any | any[], property: string, identifier: string, fields: string[]) => {
    return getCommonInUsers({
        users: Array.isArray(user) ? user : [user],
        property,
        identifier,
        formatter: (item: any) => pick(item, fields),
    });
};
